export default __webpack_public_path__ + "static/media/sort_up.df62bd41.svg";